const VendorTransportMovementMenuConfig = [
    {
      heading: 'Daily Transactions', 
      route: '#',
      name: 'daily_movementsss',
      pages: [
        {
          heading: 'Transport Transactions',
          route: '/external-vendor/transport-management',
        },
        {
          heading: 'Downloads transactions',
          route: '/external-vendor/transport-management/downloads',
        },
        {
          heading: 'Purchase',
          route: '/external-vendor/transport-management/purchase',
        },
      ],
    },
  ];
  export default VendorTransportMovementMenuConfig;
  